import { ContainerTypes, Status } from "@/types/containerTypes";
import { ContainerTreeObject } from "../types/navigationTypes";

export function containerBackgroundColor(containerTreeObject: ContainerTreeObject): string {
  if (containerTreeObject.container.containerType === ContainerTypes.Section) {
    if (containerHasFailedStep(containerTreeObject)) {
      return 'bg-danger-subtle';
    }
    if (containerCompleted(containerTreeObject)) {
      return 'bg-success-subtle';
    }
    return '';
  }
  if (containerTreeObject.container.containerType === ContainerTypes.Step) {
    if (containerTreeObject.container.status === Status.FAILED) {
      return 'bg-danger-subtle';
    }
    if (containerTreeObject.container.status === Status.PASSED) {
      return 'bg-success-subtle';
    }
  }
  return '';
}

export function containerHasFirstIncompleteStep(containerTreeObject: ContainerTreeObject, firstIncompleteStep: ContainerTreeObject | undefined): boolean {
  if (containerTreeObject.container.containerType === ContainerTypes.Section) {
    const childHasFirstIncompleteStep = containerTreeObject.children.map(child => {
      if (child.container.containerType === ContainerTypes.Step && firstIncompleteStep?.id === child.id) {
        return true;
      }
      if (child.container.containerType === ContainerTypes.Section) {
        return containerHasFirstIncompleteStep(child, firstIncompleteStep);
      }
      return false;
    });
    return childHasFirstIncompleteStep.some(child => child);
  }
  return false;
};

function containerCompleted(containerTreeObject: ContainerTreeObject): boolean {
  if (containerTreeObject.container.containerType === ContainerTypes.Section && containerTreeObject.children.length > 0) {
    const childCompleteStatus = containerTreeObject.children.map(child => {
      if (child.container.containerType === ContainerTypes.Step && child.container.status !== Status.PENDING) {
        return true;
      }
      if (child.container.containerType === ContainerTypes.Section) {
        return containerCompleted(child);
      }
      return false;
    });
    return childCompleteStatus.every(child => child);
  }
  return false;
};

function containerHasFailedStep(containerTreeObject: ContainerTreeObject): boolean {
  if (containerTreeObject.container.containerType === ContainerTypes.Section) {
    return containerTreeObject.children.some(child => {
      if (child.container.containerType === ContainerTypes.Step && child.container.status === Status.FAILED) {
        return true;
      }
      if (child.container.containerType === ContainerTypes.Section) {
        return containerHasFailedStep(child);
      }
      return false;
    });
  }
  return false;
};